import React, { useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Formik, Field, ErrorMessage, FieldArray, useFormik, FormikProvider } from "formik";
import * as OFMSUI from "react-bootstrap";
import HousingService from "../../../Services/HousingService";
import * as Yup from "yup";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import { Form, Table, InputGroup } from "react-bootstrap";
import allowNumbersOnly, { ModuleHeader, NumberValidation } from "../../utils/commonFunctions";
import { store } from "../../../App";
import axios from "axios";
import { cloud_url } from "../../../Services/Configuration";
import { showNotification } from "../../utils/commonFunctions";
import Swal from "sweetalert2";



const OnlineJournal = () => {

  const today = new Date().toISOString().split('T')[0];
  const history = useHistory();
  const [transactionId, setTransactionId] = useState("");
  const [VoucherList, setVoucherList] = useState([]);
  const [show, setShow] = useState(false)
  const [data, setData] = useState([])
  const [headNamesList, setheadNamesList] = useState([]);
  const [subheadNamesList, setSubheadNamesList] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleUpload = () => {
    return new Promise((resolve) => {
      const formData = new FormData();
      formData.append("file", selectedFile);

      HousingService.fileUploadUrlJV(formData)
        .then((response) => {
          resolve(response.data); // Resolve with the uploaded data
        })
        .catch((error) => {
          resolve(null);
        });
    });
  };


  const validationSchema = Yup.object({
    date: Yup.string().required("Field required"),
    description: Yup.string().required("Field required"),
    upload_copy: Yup.mixed().required("File is required"),
  });


  useEffect(() => {
    store.dispatch({ type: 'SHOW_SPINNER' })
    let params = { save_flag_Payment_Receipts_Journal: "Journal" };
    HousingService.getPaymentReceiptId(params).then((res) => { const id = res.data[0].payment_receipt_id; setTransactionId(id); });

    HousingService.fetchJournalVoucherList().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.voucher_id}>
              {item.voucher_name}
            </option>
          );
        });
        setVoucherList(options);
      }
    });

    HousingService.fetchHeadNamesDropdowns().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.headid}>
              {item.heads}
            </option>
          );
        });
        setheadNamesList(options);
      }
    });
    store.dispatch({ type: 'HIDE_SPINNER' })

  }, [])

  const getPdf = async (payment_receipt_id, callback) => {
    try {
      const res = await HousingService.getjournalpdf(payment_receipt_id);
      const url = window.URL.createObjectURL(
        new Blob([res.data], { type: "application/pdf" })
      );
      window.open(url, "_blank"); // Open the PDF in a new tab or window
      if (callback) {
        callback(); // Call the callback function to reset the form and reload
      }
    } catch (error) {
      console.error("Error getting PDF:", error);
    }
  };

  const formik = useFormik({
    initialValues: {
      payment_receipt_id: transactionId,
      date: "",
      voucher_id: "",
      description: "",
      upload_copy: selectedFile,
      dummy_journal_voucher_heads_Req: [{ headid: "", subheadid: "", debit: "", credit: "" }],
      debit: "",
      credit: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { setFieldError }) => {
      try {
        const totalDebit = values.dummy_journal_voucher_heads_Req.reduce(
          (acc, item) => acc + Number(item.debit || 0),
          0
        );
        const totalCredit = values.dummy_journal_voucher_heads_Req.reduce(
          (acc, item) => acc + Number(item.credit || 0),
          0
        );

        if (totalDebit !== totalCredit) {
          // alert("Total Credit and Debit amounts must be equal.");
          showNotification("warning", "Total Credit and Debit amounts must be equal.");

          return;
        }

        if (totalDebit === 0 || totalCredit === 0) {
          // alert("Please enter Amount");
          showNotification("warning", "Please enter Amount");
          return;
        }

        if (!selectedFile) {
          setFieldError("upload_copy", "File is required");
          return;
        }

        Swal.fire({
          text: "Do you want Submit?",
          icon: "success",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              values.debit = totalDebit;
              values.credit = totalCredit;

              let formData = { ...values };
              formData["payment_receipt_id"] = transactionId;
              formData["dummy_journal_voucher_heads_Req"] = values?.dummy_journal_voucher_heads_Req;

              console.log("Payload before file upload:", formData);

              const uploadedData = await handleUpload(); // Upload the file
              setUploadedFile(uploadedData);
              formData.upload_copy = uploadedData;

              const res = await HousingService.Generation_Journal_Insertion(formData);

              if (res?.data?.SCODE === "01") {
                showNotification("success", "Submitted successfully");
                await getPdf(formData?.payment_receipt_id, () => {
                  window.location.reload();
                });
              } else if (res?.data?.SCODE === "04" || res?.data?.SCODE === "05") {
                showNotification("warning", res?.data?.SDESC);
              } else {
                showNotification("error", res?.data?.SDESC);
              }
            } catch (error) {
              console.error("Error uploading file:", error);
              showNotification("error", "An error occurred during form submission");
            }
          }
        });
      } catch (error) {
        console.error("Unexpected error:", error);
        showNotification("error", "File name should not contain symbols or special characters.");
      }
    },
  });


  const displaydescription = (e) => {
    setSubheadNamesList([]);
    let voucher_id = e.target.value;
    store.dispatch({ type: 'SHOW_SPINNER' });
    HousingService.fetchJournalVoucherDescription(voucher_id)
      .then((res) => {
        if (res.data) {
          setData(res.data);
          formik.setFieldValue("description", res.data[0].description);
          const updatedVoucherHeads = res.data.map((item) => ({
            headid: item.headid || "",
            subheadid: item.subheadid || "",
            headname: `${item.headid}-${item.headname} (${item.headid})`,
            debit: "",
            credit: ""
          }));
          formik.setFieldValue("dummy_journal_voucher_heads_Req", updatedVoucherHeads);
          setShow(true);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };

  const subhandleHeadNames = (i) => {
    console.log("formik.values.dummy_journal_voucher_heads_Req[i]?.headid", formik.values.dummy_journal_voucher_heads_Req[i]?.headid)
    let selectedheadname = formik.values.dummy_journal_voucher_heads_Req[i]?.headid
    HousingService.fetchSubHeadName(selectedheadname).then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.subheadseqid}>
              {item.subheads}
            </option>
          );
        });
        setSubheadNamesList((prevState) => ({ ...prevState, [i]: options, }))
      }
    })
    return undefined;
  }

  return (
    <>
      <NavigationServicesHeader />
      <FormikProvider value={formik}>
        <Form onSubmit={formik.handleSubmit}>
          <ModuleHeader title="Online Report Journal Voucher" />
          <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
            <OFMSUI.Row>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" >
                <label> <b>Transaction Id No</b> </label> <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span>
                <Field
                  value={transactionId}
                  name="payment_receipt_id"
                  className={formik.touched.payment_receipt_id && formik.errors.payment_receipt_id ? "form-control is-invalid" : "form-control"}
                  type="text"
                  disabled={true}
                />
                {formik.touched.payment_receipt_id && formik.errors.payment_receipt_id ? (<div className="invalid-feedback"> {formik.errors.payment_receipt_id} </div>) : null}
              </OFMSUI.Col>

              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" >
                <label> <b>Date</b> </label> <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span>
                <Field name="date" className={formik.touched.date && formik.errors.date ? "form-control is-invalid" : "form-control"} type="date" max={today} min="2023-01-01" />
                {formik.touched.date && formik.errors.date ? (<div className="invalid-feedback">{formik.errors.date}</div>) : null}
              </OFMSUI.Col>

              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" >
                <label> <b>Voucher No</b> </label> <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span>
                <Field name="voucher_id" component="select" onChange={(e) => { formik.handleChange(e); displaydescription(e) }} className={formik.touched.voucher_id && formik.errors.voucher_id ? "form-control is-invalid" : "form-control"} >
                  <option value="">Select</option>
                  {VoucherList}
                </Field>
                {formik.touched.voucher_id && formik.errors.voucher_id ? (<div className="invalid-feedback">{formik.errors.voucher_id}</div>) : null}

              </OFMSUI.Col>

              <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="" >
                <label> <b>Description</b> </label>
                <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span>
                <Field name="description" as="textarea" className={formik.touched.description && formik.errors.description ? "form-control is-invalid" : "form-control"} />
                
                {formik.touched.description && formik.errors.description ? (<div className="invalid-feedback">{formik.errors.description}</div>) : null}
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="m-2">
                <div>
                  <label> <b>File Upload (File name should not contain symbols or special characters.)</b> <span className="text-danger">*</span> </label>
                  <InputGroup>
                    <input
                      type="file"
                      name="upload_copy"
                      onChange={(event) => { handleFileChange(event); formik.setFieldValue("upload_copy", event.target.files[0]); }}
                      className="form-control"
                      accept=".pdf"
                    />
                  </InputGroup>
                  <ErrorMessage name="upload_copy" component="div" className="text-danger" />
                </div>
              </OFMSUI.Col>

            </OFMSUI.Row>
            {show && (
              <>
                <OFMSUI.Row className="p-4">
                  <Table striped bordered hover>
                    <thead className="fw-bold">
                      <tr className="table_countshead">
                        <td>S.No</td>
                        <td style={{ width: "50%" }}>Heads Name - Head ID</td>
                        <td style={{ width: "15%" }}>SubHeads Name </td>
                        <td>Debit </td>
                        <td>Credit</td>
                        <td>Add Subheads</td>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.length === 0 ? (
                        <tr>
                          <td colSpan="5" style={{ fontSize: "15px", textAlign: "center" }}>
                            No details found
                          </td>
                        </tr>
                      ) : (
                        data?.map((item, i) => (
                          <tr key={i} style={{ textAlign: "initial" }}>
                            <td>{i + 1}</td>
                            <td>
                              <Field
                                className="form-control"
                                name={`dummy_journal_voucher_heads_Req[${i}].headid`}
                                type="text"
                                value={`${item.headname} (${item.headid})`} // Display formatted headname
                                readOnly
                              />
                            </td>
                            <td>
                              <Field
                                className="form-control"
                                name={`dummy_journal_voucher_heads_Req[${i}].subheadid`}
                                component="select"
                                onChange={(e) => {
                                  formik.handleChange(e);
                                }}
                              >
                                <option value="">Select</option>
                                {subheadNamesList[i]}
                              </Field>
                            </td>
                            <td>
                              <Field
                                name={`dummy_journal_voucher_heads_Req[${i}].debit`}
                                className="form-control"
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  formik.setFieldValue(
                                    `dummy_journal_voucher_heads_Req[${i}].credit`,
                                    0
                                  );
                                }}
                              />
                            </td>
                            <td>
                              <Field
                                name={`dummy_journal_voucher_heads_Req[${i}].credit`}
                                className="form-control"
                                type="text"
                                onKeyPress={(e) => NumberValidation(e)}
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  formik.setFieldValue(
                                    `dummy_journal_voucher_heads_Req[${i}].debit`,
                                    0
                                  );
                                }}
                              />
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-success btn-sm"
                                onClick={() => subhandleHeadNames(i)}
                              >
                                Add
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>


                    <tfoot>
                      <tr>
                        <td colSpan="3" style={{ textAlign: "right" }}>Total</td>
                        <td>
                          {data && data.length > 0
                            ? data.reduce(
                              (totalDebit, item, i) =>
                                totalDebit + Number(formik.values.dummy_journal_voucher_heads_Req[i]?.debit || 0),
                              0
                            )
                            : 0}
                        </td>
                        <td>
                          {data && data.length > 0
                            ? data.reduce(
                              (totalCredit, item, i) =>
                                totalCredit + Number(formik.values.dummy_journal_voucher_heads_Req[i]?.credit || 0),
                              0
                            )
                            : 0}
                        </td>
                        <td></td>
                      </tr>
                    </tfoot>

                  </Table>

                </OFMSUI.Row>
                <OFMSUI.Row>
                  <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center">
                    <button type="submit" className="btn btn-success">Submit</button>
                  </OFMSUI.Col>
                </OFMSUI.Row>
              </>
            )}



          </OFMSUI.Container>
        </Form>
      </FormikProvider>

    </>
  );
};

export default OnlineJournal;
